module.exports = __webpack_public_path__ + "img/_Boneboy.086ca3bf.png";